module.exports = __webpack_public_path__ + "img/share-tip.76b2e10e.png";